var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('personal-setting-form',{attrs:{"personal-setting-data":_vm.personalSettingData},on:{"updateEditData":_vm.updateEditData}})}
var staticRenderFns = []

export { render, staticRenderFns }